import type { ChannelStateConsistencyCheckResultsParams } from './types';

class ChannelStateConsistencyCheckResult {
  readonly missingPeers: string[];

  readonly missingProducers: string[];

  readonly consumersWithInconsistentState: string[];

  readonly producersWithInconsistentState: string[];

  readonly peersWithInconsistentAppData: string[];

  constructor(params: ChannelStateConsistencyCheckResultsParams) {
    this.missingPeers = params.missingPeers;
    this.missingProducers = params.missingProducers;
    this.consumersWithInconsistentState = params.consumersWithInconsistentState;
    this.producersWithInconsistentState = params.producersWithInconsistentState;
    this.peersWithInconsistentAppData = params.peersWithInconsistentAppData;
  }

  hasInconsistencyCases(): boolean {
    return this.missingPeers.length > 0
      || this.missingProducers.length > 0
      || this.consumersWithInconsistentState.length > 0
      || this.producersWithInconsistentState.length > 0
      || this.peersWithInconsistentAppData.length > 0;
  }
}

export default ChannelStateConsistencyCheckResult;
